import { useState } from 'react'
import { Field } from '@progress/kendo-react-form'

import {
  FormTextArea,
  FormDropDownList,
  FormDropDownListFilter,
  FormDatePicker,
} from '../FormComponents'
import { requiredValidator } from '../Validators'

type convertProps = {
   worktypeId: {
      text: string
      value: number
    },
    followupDate: string
}

const QuoteConvertForm = (props: any) => {

   const [convertData, setConvertData] = useState({
    worktypeId: {
      text: '',
      value: 0,
    },
    followupDate: '',
  })

  const handleQuoteConvert = () => {
   props.onHandleConvertSubmit(convertData)
  }


   return (
      <div>
         <legend
            className={'k-form-legend'}
            style={{
            color: 'rgb(36,32,56)',
            paddingBottom: '1rem',
            fontWeight: 'bold',
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            }}
         >
            Convert to quote:
         </legend>

         <Field
            data={props.onWorktypeData}
            name={'worktypeId'}
            component={FormDropDownList}
            label={'Choose the type of work:'}
            validator={requiredValidator}
            onChange={(e) => {
            setConvertData({
               ...convertData,
               worktypeId: {
                  ...e.value,
                  value: parseInt(e.value.value, 10),
               },
            })
            }}
         />

         <Field
            name={'followupDate'}
            component={FormDatePicker}
            label={'Quote due date:'}
            validator={requiredValidator}
            onChange={(e) => {
            setConvertData({ ...convertData, followupDate: e.value })
            }}
         />

         <div
            style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            padding: '1rem 2rem 1rem 2rem',
            position: 'relative',
            zIndex: '150',
            }}
         >
            <button onClick={handleQuoteConvert} className='form__edit__button accept'>
               Create Quote
            </button>
            <button onClick={props.onHandleConvertDisplay} className='form__edit__button reject'>
               Cancel Convert
            </button>
         </div>
      </div>
   );
}

export default QuoteConvertForm;